export default __webpack_public_path__ + "static/media/EAST2470.34I-34270_-18521_0.47d8d2b1.jpg";